export default __webpack_public_path__ + "static/media/Proselite Armbands.f543c7e0.jpg";